<template>
  <div class="">
    <transition name="filtro">
     <Filtro v-show="$store.getters.isFiltroOpen" :opId="opId" ref="filtro"></Filtro>
    </transition>
    <transition name="filtro">
     <FiltroTickets v-show="$store.getters.isFiltroTicketsOpen"></FiltroTickets>
    </transition>
    <transition name="fade">
      <Carrito v-if="$store.getters.isCarritoModalOpen"></Carrito>
    </transition>
    <transition name="fade">
      <div v-if="!$store.getters.isTicketsOpen">
      <!-- <ul class="unishop-list uf-list" v-bind:style= "[$store.getters.isFiltroOpen ? {'left' : '323px'} : {}]"> -->
       <!-- <ul v-bind:class = "($store.getters.isFiltroOpen)?'unishop-list uf-list go-right':'unishop-list uf-list'" v-if="!$store.getters.isTicketsOpen">
          <li class="unishop-item unishop-col-three uf-item" v-for="product in products" :key="product.id">
            <a @click="openModal(product)">
              <Productos :product="product"></Productos>
            </a>
          </li>
      </ul> -->
        <div v-if="cargando" class="cargando">
            <v-progress-circular
            indeterminate
            color="#2562a4"
          ></v-progress-circular>
        </div>
        <div v-else>
          <div class="unishop-list uf-list productos-list mt-5" v-bind:class = "($store.getters.isFiltroOpen || $store.getters.isBusquedaOpen)?'go-right':'go-left'" >
            <masonry v-if="tienda"
              :cols="{default: 4, 1200: 3, 700: 2, 400: 1}"
              :gutter="{default: '0px', 700: '15px'}"
              >
              <div class="px-2 unishop-item" v-for="product in productos" :key="product.id">
                <a @click="openModal(product)">
                  <Productos :product="product" :opId="opId"></Productos>
                </a>
              </div>
            </masonry>
            <ul v-else class="productos-look">             
              <!--:cols="{default: 3, 1200: 3, 1024: 2, 700: 1, 400: 1}"
              :gutter="{default: '30px', 700: '15px'}"-->
              <li class="unishop-item px-3" v-for="product in productos" :key="product.id">
                 <ProductosLook :product="product"></ProductosLook>
              </li>
            </ul>
          </div>
          <div class="no-productos" v-if="productos.length === 0">
            <v-alert
              :value="true"
              color="primary"
              class="mx-5 primary-color"
              outline
              ><v-icon class="mr-2">search_off</v-icon>{{ noProductLabel }}
            </v-alert>
          </div>
        </div>
        <Pagination></Pagination>
      </div>
    </transition>
    <transition name="fade">
      <!-- <ul class="unishop-list uf-list" v-bind:style= "[$store.getters.isFiltroOpen ? {'left' : '323px'} : {}]"> -->
       <ListaTicketsAparcados v-if="$store.getters.isTicketsOpen"></ListaTicketsAparcados>
    </transition>
    <transition name="fade">
      <modal-detalle :producto="prodAux" :opId="opId" v-if="modal" v-on:cerrar="modal = false"></modal-detalle>
    </transition>
  </div>
</template>
<script>
import Filtro from '../search/Filtro';
import FiltroTickets from '../search/FiltroTicketsAparcados';
import Productos from '../Products';
import ProductosLook from '../ProductsLook';
import Carrito from '../modal/Checkout';
import DetalleProducto from '../modal/DetalleProducto';
import filtroUtil from '../../assets/filters';
import ListaTicketsAparcados from '../tickets/ListaTicketsAparcados';
import Pagination from '../footer/Pagination';
import { TiendaApiService } from '@/api/TiendaApiService'
import { Util } from '@/api/Util'

const tiendaApiService = new TiendaApiService()
const util = new Util()

export default {
  name: 'productsList',
  
  components: { ProductosLook, Productos, Filtro, Carrito, 'modal-detalle' : DetalleProducto, ListaTicketsAparcados, Pagination, FiltroTickets },
  
  data () { 
    return {
      id: '',
      noProductLabel: 'No se han encontrado productos',
      // productsFiltered: [],
      productos: [],
      modal: false,
      idArtic : "",
      prodAux : "",
      opId: this.$store.getters.getIdTienda,
      npag: this.$store.getters.getNpag,
      cargando: false
    };
  },
  props: {
    tienda: Boolean
  },
  computed: {
    // products () {
    //   if (this.$store.state.userInfo.hasSearched) {
    //     return this.getProductBy();
    //   } else {
    //     return this.$store.state.products;
    //   }
    // },
    hasSearched () {
      return this.$store.state.userInfo.hasSearched;
    },
    cambiotienda () {
      return this.$store.getters.getIdTienda;
    },
    cambioPag () {
      return this.$store.getters.getNpag;
    }
  },
  watch: {
    cambiotienda (value) {
      this.opId = value;
      this.init();
    },
    cambioPag (value) {
      this.npag = value;
      this.init();
    },
    hasSearched (value) {
      this.init();
    }
  },
  mounted() {
    this.$store.commit('cambioPag', 1)
    this.init();
  },
  methods: {
    init() {
      // if (this.$store.state.userInfo.hasSearched !== 0) {
      //    this.getProductBy() 
      // } else {
      //   this.getAllArticulos()
      // }
      this.getProductBy()
    },
    getAllArticulos() {
      this.cargando = true
      tiendaApiService.getAllArticulos(this.npag - 1)
          .then(data => {
            this.cargando = false
            if (data) {
              this.productos=data.content
              this.$store.state.totalPag=data.totalPages
            }
            else {   
            this.productos=[]
             util.mostrarEnConsola('tiendaApiService - getAllArticulos', data.length, 'No hay articulos')
            }
            util.mostrarEnConsola('tiendaApiService - getAllArticulos', data.length, 'OK')
            
          })
          .catch(error => {
            this.cargando = false
            //this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
            this.productos=[]
            util.mostrarEnConsola('tiendaApiService - getAllArticulos', error, 'ERROR')
          })
    },
    openModal (prod) {
      this.prodAux = prod
      this.modal = true
    },
    // getProductBy () {
    //   this.productsFiltered = this.$store.state.products;
    //   if (this.$store.state.userInfo.productTitleSearched !=='') {
    //     let titleSearched = this.$store.state.userInfo.productTitleSearched;
    //     this.productsFiltered = filtroUtil.getByTitle(this.productsFiltered, titleSearched);
    //   }
    //   if (this.$store.state.userInfo.priceSearched !==0) {
    //     let priceSearched = this.$store.state.userInfo.priceSearched;
    //     this.productsFiltered = filtroUtil.getByPrice(this.productsFiltered, priceSearched);
    //   }
    //   return this.productsFiltered;
    // }
    getProductBy () {
      var filtro={
        opid: this.opId,
        npag: this.npag,
        stock: false
      }
      let busqueda = false
     
      if (this.$store.state.userInfo.productEanSearched !=='') {
        /* miramos si hay busqueda por ean */
        let ean = this.$store.state.userInfo.productEanSearched;
        Object.assign(filtro, {ean: ean})
        busqueda = true
      } else if (this.$store.state.userInfo.productLocalizadorSearched !=='') {
         /* miramos si la busqueda es por localizador */
        let localizador = this.$store.state.userInfo.productLocalizadorSearched;
        Object.assign(filtro, {localizador: localizador})
        busqueda = true
      } 
      if (this.$store.state.userInfo.stockOnlineSearched) {
        //TODO: almacen online para textura
        filtro.opid = 84
      }
      if (!busqueda) {
        /** la busqueda es por el filtro */
        let modelo = this.$store.state.userInfo.productTitleSearched;
        Object.assign(filtro, {modelo: modelo})
        let temporada = this.$store.state.userInfo.productTemporadaSearched;
        Object.assign(filtro, {temporada: temporada})
        let color = this.$store.state.userInfo.productColorSearched;
        Object.assign(filtro, {color: color})
        let talla = this.$store.state.userInfo.productTallaSearched;
        Object.assign(filtro, {talla: talla})
        let seccion = Object.assign(this.$store.state.userInfo.productSeccionSearched);
        seccion = seccion.filter(v => !v.id.includes("SECCIONPADRE"));
        let familia = this.$store.state.userInfo.productFamiliaSearched;
        familia.forEach(element => seccion.push(element));
        Object.assign(filtro, {seccion: seccion})
        // console.log(filtro.seccion)
        let precio = this.$store.state.userInfo.priceSearched;
        Object.assign(filtro, {precio: precio})
        if (this.$store.state.userInfo.tiendaSearched !== [] && this.$store.state.userInfo.tiendaSearched !== null && this.$store.state.userInfo.tiendaSearched.length !== 0) {
         filtro.stockOpId = this.$store.state.userInfo.tiendaSearched.msopid
         filtro.stock = true
        } else {
          /****  cambio: sino se elige tienda en el combo buscamos en toda la organizacion    *****/
          filtro.opid = 0
        }
      }  
      this.cargando = true
      //console.log(filtro)
      tiendaApiService.findArticulos(filtro)
          .then(data => {
            this.cargando = false
            if (data) {
              this.productos=data.data.content
              this.$store.state.totalPag=data.data.totalPages
              if (data.data.content.length === 1) {
                this.openModal(data.data.content[0])
              }
            }
            else {   
             this.productos=[]
             util.mostrarEnConsola('tiendaApiService - findArticulos', data.length, 'No hay articulos')
            }            
          })
          .catch(error => {
            this.cargando = false
            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
            this.productos=[]
            util.mostrarEnConsola('tiendaApiService - findArticulos', error, 'ERROR')
          })
      //return this.$store.state.products;
    }
  }

};
</script>

